import { render } from "./About.vue?vue&type=template&id=78df0059"
const script = {}

import exportComponent from "/Applications/MAMP/htdocs/vueproject/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__